import React from 'react';


function PartnerBenefitsIcons(props) {
  return (
    <div className="w-full md:w-1/2 mx-auto my-2 self-start">
      <img alt='benefits' className="w-1/2 mx-auto pb-2" src={props.icon} />
      <p className="w-full md:mx-0 text-xs xl:text-base text-lpGray text-center">{props.description}</p>
    </div>
  )
}

export default PartnerBenefitsIcons
